<template>
    <div class="comment-answer__inner">
        <div class="comment-wrapper">
            <div class="comment" :id="idSelector">
                <CommentHeader :comment="comment" :comment-answer-to="commentAnswerTo"/>

                <div class="comment__content comment__content--reply">
                    <CommentText :comment="comment"/>

                    <div class="comment__bottom">
                        <ReplyBtn :replay-to-id="comment.id" v-if="isCommentShowing"/>
                        <MoreActionsBtn :comment="comment" v-if="isCommentShowing"/>
                        <LikeBtn :comment="comment" :is-mobile="true"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="comment-reply-wrapper comment-reply-wrapper--reply">
            <transition name="comment-input-fade">
                <Input :key="comment.id" :answer-to-id="comment.id"/>
            </transition>
        </div>
    </div>
</template>

<script>
    import CommentHeader from "VueApps/comments/components/comment/parts/CommentHeader.vue";
    import ReplyBtn from "VueApps/comments/components/comment/parts/ReplyBtn.vue";
    import MoreActionsBtn from "VueApps/comments/components/comment/parts/MoreActionsBtn.vue";
    import CommentText from "VueApps/comments/components/comment/parts/CommentText.vue";
    import LikeBtn from "VueApps/comments/components/comment/parts/LikeBtn.vue";
    import Input from "VueApps/comments/components/input/Input.vue";
    import {getUniqueSelector} from "VueApps/comments/services/highlight";
    import {isCommentShowing} from "VueApps/comments/services/commentStatusResolver";

    export default {
        name: "Answer",
        components: {
            MoreActionsBtn,
            ReplyBtn,
            CommentHeader,
            CommentText,
            Input,
            LikeBtn
        },
        props: {
            comment: {
                type: Object,
                required: true
            },
        },
        computed: {
            commentAnswerTo: function () {
                return this.comment.answerToId !== null ?
                    this.$store.state.componentState.comments[this.comment.answerToId] :
                    this.$store.state.componentState.comments[this.comment.parentId];
            },
            idSelector: function () {
                return getUniqueSelector(this.comment.id);
            },
            isCommentShowing: function () {
                return isCommentShowing(this.comment);
            },
        }
    }
</script>

<style scoped>

</style>
